import Joi from 'joi';

/**
 * Schema for rental duration policy config validation.
 * Threshold is optional/nullable (round semantics). When present as a number, must be 1..1440.
 */
export const rentalDurationConfigSchema = () =>
	Joi.object({
		dayThresholdMinutes: Joi.number()
			.min(1)
			.max(1440)
			.integer()
			.allow(null)
			.optional(),
	}).unknown(false);
